export const chartCopy = {
  titles: {
    avgDuration: 'Avg. Duration',
    duration: 'Duration',
    flakeScore: 'Flake Rate',
    frequency: 'Frequency',
    latestStatus: 'Latest Status',
    passRate: 'Success Rate',
    status: 'Status',
    statusBreakdown: 'Status Breakdown',
    statusChart: 'Status Chart',
    statusTimeline: 'Runs Over Time',
    suiteHistory: 'Suite History',
  },
} as const;

export type ChartTitleKey = keyof typeof chartCopy.titles;

export const getChartTitle = (key: ChartTitleKey): string => chartCopy.titles[key];

export const getChartNoDataTitle = (
  metric: Extract<ChartTitleKey, 'avgDuration' | 'flakeScore' | 'frequency' | 'passRate'>,
): string => `No ${getChartTitle(metric)} Data`;

export const getChartCopySamples = (): string[] => [
  ...Object.values(chartCopy.titles),
  getChartNoDataTitle('passRate'),
  getChartNoDataTitle('frequency'),
  getChartNoDataTitle('flakeScore'),
  getChartNoDataTitle('avgDuration'),
];
